;(function () {
  'use strict'

  // Tracks clicks on the entry links that navigate to the Coffee Machine Finder
  // page. These links are author-placed inside generic components (teaser, hero
  // slider, button, in-content link, ...), so they have no single owning
  // component - we bind by href, mirroring Launch Rule 46's selector. This is
  // distinct from the in-finder "coffee machine finder" events fired by the
  // finder app itself.
  function onDocumentReady() {
    const coffeeMachineFinderLinks = document.querySelectorAll('a[href*="coffee-machine-finder.html"]')

    for (const coffeeMachineFinderLink of coffeeMachineFinderLinks) {
      coffeeMachineFinderLink.addEventListener('click', function () {
        window.adobeDataLayer?.push({
          event: 'cmp:click',
          eventInfo: {
            reference: 'coffee machine finder cta',
            requestUrl: this.getAttribute('href'),
          },
        })
      })
    }
  }

  if (document.readyState !== 'loading') {
    onDocumentReady()
  } else {
    document.addEventListener('DOMContentLoaded', onDocumentReady)
  }
})()
